export default __webpack_public_path__ + "static/mini-van-dfsk-2a23ae052590366a988fad8682ee2f8d.png";